module.exports = __webpack_public_path__ + "static/img/network_widgrt_1.feb359a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/network_widgrt_1.png
// module id = dDjg
// module chunks = 11